import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const pricePerformanceAC: CriterionType[] = [
  {
    id: 'PV-70_1d',
    label: 'Price change (1D) (%)',
    shortLabel: '%Chg1D',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['1d'],
    withRange: true,
  },
  {
    id: 'PV-70_5d',
    label: 'Price change (5D) (%)',
    shortLabel: '%Chg5D',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['5d'],
    withRange: true,
  },
  {
    id: 'PV-70_4wk',
    label: 'Price change (4W) (%)',
    shortLabel: '%Chg4W',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['4wk'],
    withRange: true,
  },
  {
    id: 'PV-70_13wk',
    label: 'Price change (13W) (%)',
    shortLabel: '%Chg13W',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['13wk'],
    withRange: true,
  },
  {
    id: 'PV-70_26wk',
    label: 'Price change (26W) (%)',
    shortLabel: '%Chg26W',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['26wk'],
    withRange: true,
  },
  {
    id: 'PV-70_52wk',
    label: 'Price change (52W) (%)',
    shortLabel: '%Chg52W',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['52wk'],
    withRange: true,
  },
  {
    id: 'PV-70_wtd',
    label: 'Price change (WTD) (%)',
    shortLabel: '%ChgWTD',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['wtd'],
    withRange: true,
  },
  {
    id: 'PV-70_mtd',
    label: 'Price change (MTD) (%)',
    shortLabel: '%ChgMTD',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['mtd'],
    withRange: true,
  },
  {
    id: 'PV-70_ytd',
    label: 'Price change (YTD) (%)',
    shortLabel: '%ChgYTD',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['ytd'],
    withRange: true,
  },
  {
    id: 'PV-70_qtd',
    label: 'Price change (QTD) (%)',
    shortLabel: '%ChgQTD',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    timeOptions: ['qtd'],
    withRange: true,
  },
  {
    id: 'PP-50',
    label: 'Change from 52W low (%)',
    shortLabel: '%From52WLow',
    unit: '%',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PP-60',
    label: 'Change from 52W high (%)',
    shortLabel: '%From52WHigh',
    unit: '%',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PV-40',
    label: 'Price 12M high',
    shortLabel: 'Prc12MHi',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'PV-50',
    label: 'Price 12M low',
    shortLabel: 'Prc12MLo',
    group: AC_GROUPS.pricePerformance,
    type: AC_TYPES.normal,
    withRange: true,
  },
];

export default pricePerformanceAC;
